"use client"

import clsx from "clsx"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import {
  npPageGap2ClassName,
  npPageGapClassName,
  npSectionMtClassName,
} from "src/components/np-design/components/constants"
import { NpIconName } from "src/components/np-design/components/NpIcon"
import { NpHeading } from "src/components/np-design/components/NpSubtitle"
import { NpUppercaseHeading } from "src/components/np-design/components/NpUppercaseHeading"
import { socialLinks } from "src/components/np-design/sections/footer/socialLinks"
import { useEventCallback } from "src/hooks/useEventCallback"
import { posthogCapture } from "src/integrations/posthog/events"

export type SocialLinkData = {
  href: string
  name: string
  icon: NpIconName
}

type SocialLinkProps = {
  link: SocialLinkData
}

const SocialLink = ({ link }: SocialLinkProps) => {
  const onClick = useEventCallback(() => {
    posthogCapture("social_link_clicked", { ...link, location: "home" })
  })

  return (
    <NpButton
      variant="outlined"
      size="lg"
      href={link.href}
      iconNameLeft={link.icon}
      aria-label={link.name}
      title=""
      onClick={onClick}
    />
  )
}

export const NpHomePageSocialSection = () => {
  return (
    <section className={clsx(npSectionMtClassName, npPageGap2ClassName, "flex flex-col")}>
      <div className={clsx(npPageGapClassName, "flex flex-col")}>
        <NpUppercaseHeading as="p">Mehr Einblicke</NpUppercaseHeading>
        <NpHeading as="h2">Folge uns auf Social Media</NpHeading>
      </div>

      <nav className="flex flex-col items-center">
        <ul className={clsx(npPageGapClassName, "flex items-center")}>
          {socialLinks.map((link, index) => {
            return (
              <li key={index} className="flex flex-col items-center gap-4">
                <SocialLink link={link} />
                <div className="font-normal">{link.name}</div>
              </li>
            )
          })}
        </ul>
      </nav>
    </section>
  )
}
